/* eslint-disable no-multiple-empty-lines */
import React, { useCallback } from 'react'
import Column from './column'
import { RhyBusButton } from '@rhybus/button'

interface RowProps {
    dynamicContainerId: any,
    // id: string;
    isSelected: boolean;
    layout: number[] | null; // Layout determines the column classes
    // onSelect: () => void;
    onChildDrop: (containerId: string, rowId: string, children: { id?: string; type?: string; label?: string; isInfo?: boolean; isMandatory?: boolean }) => void;
    onChildSelect: (childId: string | null, childType: string | null, childLabel: string | null, childInfo: boolean | null, childMandatory: boolean | null) => void;
    getChildrenLengths: any;
    formSettings: any
    getChildSelects?: any
    changedLabel?: any
    setSelectChilds?: any
    selectedContainer?: any
    setContainersData: any
    setSelectedContainer: any
    containerId: any
    clickedId?: any
    rowClassName?: string
    rowData: { id: string; childData: { id: string; type: string; label: string; isInfo: boolean; isMandatory: boolean }[]; isDataRow?: boolean }[],
    selectedRowId?: string | undefined,
    selectedChildId: string | null,
    setSelectedChildId: React.Dispatch<React.SetStateAction<string | null>>
    setSelectedWholeRowId: React.Dispatch<React.SetStateAction<string | null>>
    selectedWholeRowId: string | null
    containersData: { id: string, rowData: { id: string; childData: { id: string; type: string; label: string; isInfo: boolean; isMandatory: boolean }[] }[] }[],
    setSelectedType: React.Dispatch<React.SetStateAction<string | null>>
    setSelectedSubChild: React.Dispatch<React.SetStateAction<string | null>>
    setSelectedLayout: React.Dispatch<any>
    selectedLayout: any
}

const Row: React.FC<RowProps> = (props) => {
    const {
        selectedChildId,
        setSelectedChildId,
        dynamicContainerId,
        onChildSelect,
        isSelected,
        layout,
        onChildDrop,
        containersData,
        getChildrenLengths,
        setSelectedLayout,
        selectedLayout,
        getChildSelects, formSettings, changedLabel, setSelectChilds, selectedContainer, rowData, setContainersData, setSelectedContainer, containerId, selectedRowId, setSelectedWholeRowId, selectedWholeRowId, setSelectedSubChild, setSelectedType
    } = props

    const moveRow = useCallback((dragIndex: number, hoverIndex: number) => {
        setContainersData((prevData: any) =>
            prevData.map((container: any) => {
                if (container.id !== dynamicContainerId) return container
                const updatedRows = [...container.rowData]
                const [movedRow] = updatedRows.splice(dragIndex, 1)
                updatedRows.splice(hoverIndex, 0, movedRow)
                return { ...container, rowData: updatedRows }
            })
        )
    }, [dynamicContainerId, setContainersData])

    // Add Row (existing)
    const handleAddRow = () => {
        const newRowId = generateUniqueId('row')

        setContainersData((prevContainers: any) =>
            prevContainers.map((container: any) =>
                container.id === dynamicContainerId
                    ? {
                        ...container,
                        rowData: [
                            ...(container.rowData || []),
                            { id: newRowId, childData: [] },
                        ],
                    }
                    : container
            )
        )

        // ✅ auto-select new row
        setSelectedContainer(dynamicContainerId)
        setSelectedWholeRowId(newRowId)
        setSelectedChildId(null) // clear child selection
        setSelectedType(null)
        setSelectedSubChild(null)
    }
    let childCounter = 0
    const generateUniqueId = (prefix: string) => `${prefix}-${Date.now()}-${childCounter++}`
    // Add Data Row (new)
    const handleAddDataRow = () => {
        const newRowId = generateUniqueId('data-row')

        setContainersData((prevContainers: any) =>
            prevContainers.map((container: any) =>
                container.id === dynamicContainerId
                    ? {
                        ...container,
                        rowData: [
                            ...(container.rowData || []),
                            {
                                id: newRowId,
                                childData: [],
                                isDataRow: true, // optional flag
                            },
                        ],
                    }
                    : container
            )
        )

        // auto-select new data row
        setSelectedContainer(dynamicContainerId)
        setSelectedWholeRowId(newRowId)
        setSelectedChildId(null)
        setSelectedType(null)
        setSelectedSubChild(null)
    }


    return (
        <>
            <div
                id={dynamicContainerId}
                className={`row ${props?.rowClassName} ${formSettings.gutterspace.value ? formSettings.gutterspace.value : 'g-2'} ${formSettings.formsize.value ? formSettings.formsize.value : 'form-md'} ${formSettings.fontfamily.value ? formSettings.fontfamily.value : ''} ${formSettings.fontcolor.value ? formSettings.fontcolor.value : ''} ${formSettings.fontsize.value ? formSettings.fontsize.value : ''} `} //${isSelected ? 'border-radius border-primary container-active' : 'border-radius border-1'}
            >
                {rowData?.map((row: any, index: number) => (
                    <Column
                        key={row.id}
                        dynamicContainerId={dynamicContainerId}
                        rowId={row.id}
                        rowIndex={index}
                        moveRow={moveRow}
                        isDataRow={row.isDataRow}
                        isSelected={row.id === selectedWholeRowId}
                        onSelect={() => {
                            setSelectedContainer(selectedContainer === row.id ? null : row.id)
                        }}
                        layout={layout}
                        onChildDrop={onChildDrop}
                        onChildSelect={onChildSelect}
                        getChildrenLengths={getChildrenLengths}
                        getChildSelects={getChildSelects}
                        formSettings={formSettings}
                        changedLabel={changedLabel}
                        setSelectChilds={setSelectChilds}
                        childrenData={row.childData}
                        setContainersData={setContainersData}
                        setSelectedContainer={setSelectedContainer}
                        containerId={containerId}
                        selectedRowId={selectedRowId}
                        selectedChildId={selectedChildId}
                        setSelectedChildId={setSelectedChildId}
                        setSelectedWholeRowId={setSelectedWholeRowId}
                        selectedWholeRowId={selectedWholeRowId}
                        containersData={containersData}
                        setSelectedSubChild={setSelectedSubChild}
                        setSelectedType={setSelectedType}
                        selectedLayout={selectedLayout}
                        setSelectedLayout={setSelectedLayout}
                    />
                ))}
                <div className='d-flex align-items-center justify-content-end gap-2'>
                    <RhyBusButton
                        label="Add Row"
                        leftIcon='icon-rb-add font-12'
                        className="justify-content-center btn-xs add-row-button color-primary font-14"
                        onClick={handleAddRow}
                    />

                    <RhyBusButton
                        label="Content Block"
                        leftIcon='icon-rb-add font-12'
                        className="justify-content-center btn-xs add-data-button color-success font-14"
                        onClick={handleAddDataRow}
                    />
                </div>
            </div>
        </>
    )
}

export default Row
